import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AccountSandbox } from 'src/core/account/account.sandbox';
import { UserModel } from 'src/core/account/models/registerUser.model';
import { AppSettingService } from 'src/core/services/app.settings';

@Component({
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    selector: 'app-header'
})
export class HeaderComponent implements OnInit, OnDestroy {
    @Output() toggleSideBarForMe: EventEmitter<any> = new EventEmitter();

    private subs: Subscription[] = [];
    userEmail = '';
    currentLang = '';
    currentPlan = '';

    constructor(
        public accountSandbox: AccountSandbox,
        private cd: ChangeDetectorRef,
        private appSettings: AppSettingService,
        private translate: TranslateService,
        @Inject(DOCUMENT) private document: Document
    ) { }

    ngOnInit(): void {
        this.currentLang = this.translate.currentLang;
        this.document.documentElement.lang = this.translate.currentLang;

        this.translate.onLangChange.subscribe((res: LangChangeEvent) => {
            this.currentLang = res.lang;
            this.document.documentElement.lang = res.lang;
        });

        this.subs.push(this.accountSandbox.getCurrentUserData$.subscribe((res: UserModel) => {
            this.userEmail = res && res.email ? res.email : '';
            this.currentPlan = res && res.plan ? res.plan : '';
            this.cd.markForCheck();
        }));
    }

    toggleSideBar(): void {
        this.toggleSideBarForMe.emit();
        setTimeout(() => {
            window.dispatchEvent(
                new Event('resize')
            );
        }, 300);
    }

    doLout(): void {
        this.accountSandbox.doLogout();
        this.appSettings.setCurrentUser(null);
        this.accountSandbox.doClearGetCurrentUserState();
    }

    changeLang(lang: string): void {
        this.translate.use(lang);
    }

    ngOnDestroy(): void {
        this.subs.map(s => s.unsubscribe());
    }
}
